module.exports = __webpack_public_path__ + "img/icon_contact.ae4055e3.png";